import React, { useState, useEffect, useMemo, useRef, createRef } from "react";
import styles from "styles/genai/Edetail.module.scss";
import cardsstatus from "img/genai/cardstatus.svg";
import downloadicon from "img/genai/download.svg";
import suggestion from "img/genai/suggestions.svg";
import viewport from "img/genai/viewport.svg";
import tick from "img/genai/tick.svg";
import starloader from "img/genai/StarLoader.svg";
import arrowLeft from "img/genai/arrowLeft.svg";
import arrowRight from "img/genai/arrowRight.svg";
import styled from "styled-components";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { PaginationEdt } from "./PaginationEdt";
// import { PreviewModal } from "./PreviewModal";
// import LoadingCircle from "../utils/LoadingCircle";
import { downloadEDetail, fetchModules } from "../api/genapi";
import { CardSkelten } from "../utils/CardSkelten";
import cardsimg from "img/genai/images/edetailcard.svg";
import OverlayPopOver from "Uitls/OverlayPopOver";
import { getMlrStatusIcon } from "Uitls/Util";
import { ToolTipText } from "components/TooltipText";
import { fetchPreview } from "../api/genapi";
import { PreviewModal } from "./PreviewModal";
import { LoadingCircle } from "../utils/LoadingCircle";
import { ToastContainer, toast } from "react-toastify";
import ConfirmationModal from "../utils/ConfirmationModal";
import { useAutoScroll } from "./utils/AutoScroll";
import CircularProgressBar from "Uitls/CircularProgressBar";

const EdetailCardComponent = ({
  checkeDetailSelect,
  productCountry,
  messageId,
  setedtName,
  message,
  formatDateTime,
  SetedetailTextShow,
  latestMessageId,
  handleGreyOutClick,
  chatContentRef,
  setShowNewBubble,
  setTextShow,
  setGryRetrivedSlideIds
}) => {
  const [selectedCard, setSelectedCard] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [edetails, setEdetails] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [previewData, setPreviewData] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [confirmationModalProps, setConfirmationModalProps] = useState({
    message: "",
    onProceed: () => {},
    onCancel: () => {},
  });
  const [isModalLoading, setIsModalLoading] = useState(false);
  const itemsPerPage = 8;
  useAutoScroll(chatContentRef, [edetails]);
  const popoverRef = createRef();
  const isLatestMessage = messageId === latestMessageId;

  const greyOutStyle = {
    opacity: isLatestMessage ? 1 : 0.5,
    pointerEvents: isLatestMessage ? "auto" : "none",
    filter: isLatestMessage ? "none" : "grayscale(80%)",
  };

  const lastMessageId = useRef(null);

  useEffect(() => {
    if (lastMessageId.current === messageId && currentPage === 1) {
      // same message and first page, skip fetch
      return;
    }
    lastMessageId.current = messageId;

    const fetchData = async () => {
      /* same fetch code */
    };
    fetchData();
  }, [messageId, currentPage]);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const offset = (currentPage - 1) * itemsPerPage;
        const response = await new Promise((resolve) => {
          fetchModules(
            productCountry,
            (response) => resolve(response),
            offset,
            itemsPerPage
          );
        });

        if (!response) {
          throw new Error("API request failed");
        }
        if (
          !response.data ||
          response.data.length === 0 ||
          response.responseDetails?.total === 0
        ) {
          setShowNewBubble(true);
          setTextShow(true);
        }
        setEdetails(response.data || []);

        setTotalCount(response.responseDetails?.total || 0);
      } catch (error) {
        toast.error("Something went wrong.", {
          position: "top-right",
          autoClose: 5000,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [messageId, currentPage]);
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  // Custom toast with action buttons
  const showConfirmation = (message, onProceed, onCancel) => {
    setConfirmationModalProps({
      message,
      onProceed: () => {
        onProceed();
        setShowConfirmationModal(false);
      },
      onCancel: () => {
        onCancel();
        setShowConfirmationModal(false);
      },
    });
    setShowConfirmationModal(true);
  };

  const handleCardClick = (id, elem) => {
    if (selectedCard === id) {
      // updateSelectedCard(id, elem);
      return;
    }
    if (!isLatestMessage || selectedCard === null) {
      updateSelectedCard(id, elem);
      return;
    }

    showConfirmation(
      "Changing the e-Detail will cancel all previous actions. Are you sure?",
      () => {
        updateSelectedCard(id, elem);
        handleGreyOutClick();
        setGryRetrivedSlideIds(true);
      }, // Proceed
      () => console.log("Cancelled") // Cancel
    );
  };

  const updateSelectedCard = (id, elem) => {
    // handleGreyOutClick()
    setSelectedCard(id);
    checkeDetailSelect(id);
    if (id) {
      setedtName(elem.eDetailDocNumber);
    }
  };

  const handleImageClick = (ele) => {
    if (!ele.veevaPublished) return;

    setIsModalLoading(true);

    fetchPreview(ele.eDetailDocId, (response, error) => {
      // Reset loading state
      setIsModalLoading(false);

      if (error) {
        console.error("Failed to fetch preview:", error);
        return;
      }

      if (response && response.pageDetails && response.pageDetails.length > 0) {
        setPreviewData(response);
        setShowModal(true);
      }
    });
  };
  const preventContextMenu = (e) => e.preventDefault();

  const handleDownloadClick = (e, edetailNum) => {
    e.stopPropagation();
    e.preventDefault(); // Prevent any default behavior

    if (!edetailNum) {
      console.warn("Missing document ID for download.");
      return;
    }

    console.log(`Initiating download for ${edetailNum}`);

    // Add visual feedback
    const button = e.currentTarget;
    const originalText = button.textContent;
    button.textContent = "Preparing...";
    button.disabled = true;

    downloadEDetail(edetailNum, (success, error) => {
      // Restore button state
      button.textContent = originalText;
      button.disabled = false;

      if (!success) {
        // Show error to user (you can replace with your preferred notification system)
        alert(`Download failed: ${error?.message || "Unknown error"}`);
      }
    });
  };

  const handlePageChange = (newPage) => {
    if (newPage < 1 || newPage > totalPages) return;
    setCurrentPage(newPage);
    window.scrollTo({ bottom: 0, behavior: "smooth" });
  };

  // Show loading circle during initial load
  if (isLoading && edetails.length === 0) {
    return (
      <div className={styles.loadingContainer}>
        <LoadingCircle
          loaderText={[
            "Connecting to Veeva PromoMats",
            "Analysing the prompt & identifying the metadata",
            "Fetching related eDetail",
          ]}
        />
      </div>
    );
  }

  return (
    <>
      {isModalLoading && <CircularProgressBar isloading={true} />}
      {showConfirmationModal && (
        <ConfirmationModal
          message={confirmationModalProps.message}
          onProceed={confirmationModalProps.onProceed}
          onCancel={confirmationModalProps.onCancel}
        />
      )}
      <BotMessageBubble style={{ width: "77rem" }}>
        <TimeStamp>{formatDateTime(message.timestamp)}</TimeStamp>

        <article className={styles.edetailmain} style={greyOutStyle}>
          <PreviewModal
            show={showModal}
            onClose={() => setShowModal(false)}
            previewData={previewData}
          />
          {edetails.length > 0 && (
            <span className={styles.edtDetailsmsg}>
              <strong>
                Here you go! We have found some eDetails that can be used for
                new module creation. Select any one of the eDetails to proceed
                ahead.
              </strong>
            </span>
          )}
          {totalPages > 1 && (
            <PaginationEdt
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              disabled={isLoading}
            />
          )}
          {isLoading ? (
            <div className={styles.loadingContainer}>
              <div className={styles.ecardscontainer}>
                {edetails.length > 0
                  ? edetails.map((ele) => <CardSkelten key={ele.id} />)
                  : null}
              </div>
            </div>
          ) : (
            <>
              <div
                className={`${styles.ecardscontainer} ${
                  edetails.length > 0 ? "" : " "
                }`}
                ref={popoverRef}
              >
                {edetails.length > 0
                  ? edetails.map((ele) => (
                      <article
                        key={ele.eDetailDocId}
                        className={`${styles.ecardsub} ${
                          selectedCard === ele.eDetailDocId
                            ? styles.selectedCard
                            : ""
                        } ${!ele.veevaPublished ? styles.disabledCard : ""}`}
                        onClick={() =>
                          ele.veevaPublished &&
                          handleCardClick(ele.eDetailDocId, ele)
                        }
                      >
                        {selectedCard === ele.eDetailDocId && (
                          <div className={styles.selectedTick}>
                            <img src={tick} alt="selected" />
                          </div>
                        )}

                        {!ele.veevaPublished && (
                          <StyledTooltip
                            title="This eDetail is not deconstructed through NCCI, cannot be used to create module. please connect with system administrator"
                            arrow
                            placement="bottom-start"
                          >
                            <InfoIconWrapper className={styles.tooltipIcon}>
                              <img src={suggestion} alt="info" />
                            </InfoIconWrapper>
                          </StyledTooltip>
                        )}

                        <div
                          className={styles.imageContainer}
                          onClick={(e) => {
                            e.stopPropagation();
                            ele.veevaPublished && handleImageClick(ele);
                          }}
                        >
                          <img
                            onContextMenu={preventContextMenu}
                            className={styles.cardsimg}
                            src={ele.signedUrl || cardsimg}
                            alt="edetail"
                            style={{
                              objectFit: ele.signedUrl ? "fill" : "cover", // or any other fit mode
                            }}
                          />

                          {ele.veevaPublished && (
                            <div className={styles.previewOverlay}>
                              <article className={styles.previewBox}>
                                <img src={viewport} alt="view" />
                                <span>Preview</span>
                              </article>
                            </div>
                          )}
                        </div>

                        <article
                          className={`${styles.ecardbottom} ${
                            ele.isdisabled ? styles.disabledBottom : ""
                          }`}
                        >
                          <div className={styles.leftecard}>
                            <span className={styles.cardstatus}>
                              <OverlayPopOver
                                element={
                                  <img
                                    src={getMlrStatusIcon(ele.mlrStatus)}
                                    alt={ele.mlrStatus}
                                    style={{
                                      marginBottom: "3px",
                                      marginRight: "4px",
                                    }}
                                  />
                                }
                                overlayData={
                                  <ToolTipText>{ele.mlrStatus}</ToolTipText>
                                }
                                trigger={["hover", "focus"]}
                                placement="bottom"
                                classId="tooltip"
                                containerRef={popoverRef}
                              />
                              <span>
                                <strong>{ele.eDetailDocNumber}</strong>
                              </span>
                            </span>
                            <div className={styles.nameedtMain}>
                              <span className={styles.nameedetail}>Name: </span>
                              <span className={styles.nameofedetail}>
                                <strong>
                                  {ele.eDetailName.length > 20
                                    ? `${ele.eDetailName.substring(0, 16)}...`
                                    : ele.eDetailName}
                                </strong>
                              </span>
                            </div>
                          </div>
                          <div className={styles.rightecard}>
                            <img
                              src={downloadicon}
                              alt="download"
                              onClick={(e) =>
                                ele.veevaPublished &&
                                handleDownloadClick(e, ele.eDetailDocId)
                              }
                            />
                          </div>
                        </article>
                      </article>
                    ))
                  : !isLoading && (
                      <div className={styles.ecardnosres}>
                        No eDetails found matching your criteria.
                      </div>
                    )}
              </div>
            </>
          )}
        </article>
      </BotMessageBubble>
    </>
  );
};

export const EdetailCard = React.memo(
  EdetailCardComponent,
  (prevProps, nextProps) => {
    return (
      prevProps.messageId === nextProps.messageId &&
      prevProps.latestMessageId === nextProps.latestMessageId &&
      prevProps.chatContentRef === nextProps.chatContentRef
    );
  }
);

const StyledTooltip = withStyles({
  tooltip: {
    backgroundColor: "#fff",
    color: "#333",
    fontSize: "12px",
    padding: "8px",
    borderRadius: "4px",
    whiteSpace: "normal",
    wordWrap: "break-word",
    lineHeight: "1.5",
    marginTop: "7px",
    marginRight: "18px",
    maxWidth: "210px",
    boxShadow: "0px 0px 8px 0px #231F201F",
  },
  arrow: {
    color: "#fff",
    width: "35px",
    height: "12px",
    paddingLeft: "9px",
    borderWidth: "2px",
    borderColor: "#fff",
    transform: "scale(1)",
  },
})(Tooltip);

const InfoIconWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: absolute;
  top: 8px;
  right: 8px;
`;

const BotMessageBubble = styled.div`
  background: #ffffff;
  padding: 20px 20px;
  border-radius: 12px;
  max-width: 80%;
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
const TimeStamp = styled.small`
  color: #0a0a0b;
  font-size: 9px;
  margin-top: 4px;
`;
